import EmojiEmotionsOutlinedIcon from "@material-ui/icons/EmojiEmotionsOutlined"
import SentimentDissatisfiedIcon from "@material-ui/icons/SentimentDissatisfied"
import SentimentVeryDissatisfiedIcon from "@material-ui/icons/SentimentVeryDissatisfied"
import { green, red, orange } from "@material-ui/core/colors"
import {
	IQuestionStructure,
	IAnswerTheme,
	QuestionOptionsRecord,
} from "./shape"
import { PrivateRoutes } from "../../../util/routes/routes"
import { questionOptionsMap } from "./utilities"

/**
 * Four key questions
 *
 * @exports
 */
export const fourQuestionsContent = [
	"Prvo pitnaje?",
	"Drugo pitnaje?",
	"Treće pitnaje?",
	"Četvrto pitnaje?",
]

/**
 * Options for the four key questions
 *
 */
const fourQuestionOptions: QuestionOptionsRecord = {
	positive: "Da",
	negative: "Ne",
	neutral: "Nisam siguran",
}

/**
 * Generic options for the questions in the health check
 *
 */
const additionalQuestionsOptions: QuestionOptionsRecord = {
	positive: "Uveren",
	negative: "Nisam uveren",
	neutral: "Nisam siguran",
}

/**
 * Defines a list of questions used in the health check
 *
 */
export const questions: IQuestionStructure[] = [
	...questionOptionsMap(fourQuestionsContent, fourQuestionOptions),
	{
		question: "Peto pitanje?",
		options: { ...additionalQuestionsOptions },
		learnMore: PrivateRoutes.DTPlanningBusiness,
	},
	{
		question: "Šesto pitanje",
		options: { ...additionalQuestionsOptions },
		learnMore: PrivateRoutes.DTManagingCashFlow,
	},
	{
		question: "Sedmo pitanje?",
		options: { ...additionalQuestionsOptions },
		learnMore: PrivateRoutes.DTRecordKeeping,
	},
	{
		question: "Odmo pitanje?",
		options: { ...additionalQuestionsOptions },
		learnMore: PrivateRoutes.DTPlanningFinanicalCommitments,
	},
	{
		question: "Deveto pitanje?",
		options: { ...additionalQuestionsOptions },
		learnMore: PrivateRoutes.DTFundingBusiness,
	},
	{
		question: "Deseto pitanje?",
		options: { ...additionalQuestionsOptions },
		learnMore: PrivateRoutes.DTTrackingPerformance,
	},
]

/**
 * Theming for the different health check answers
 *
 * @exports
 */
export const answerTheming: IAnswerTheme[] = [
	{
		Icon: EmojiEmotionsOutlinedIcon,
		color: green[500],
		answer: "positive",
	},
	{
		Icon: SentimentVeryDissatisfiedIcon,
		color: red[500],
		answer: "negative",
	},
	{
		Icon: SentimentDissatisfiedIcon,
		color: orange[500],
		answer: "neutral",
	},
]
